export const getLocale = () => {
  // @todo: use the browser-setting locale
  return 'en-US'
}
